import { assets } from "./assets";

export const impactCategories = [
  {
    id: "Healthcare",
    slug: "healthcare",
    summary:
      "Mobile health units, telemedicine, and community health camps reaching underserved areas.",
    programs: [
      "Mobile Health Units",
      "Telemedicine Services",
      "Health Camps",
      "Medical Equipment Support",
    ],
    image: assets.impact.Healthcare,
  },
  {
    id: "Education",
    slug: "education",
    summary:
      "Digital classrooms, scholarships, and teacher training for lasting learning outcomes.",
    programs: [
      "Digital Classrooms",
      "Scholarships",
      "Teacher Training",
      "Infrastructure Development",
    ],
    image: assets.impact.Education,
  },
  {
    id: "Goshala",
    slug: "goshala",
    summary:
      "Cow rescue, shelter, veterinary care, and compassionate goshala maintenance.",
    programs: [
      "Animal Rescue",
      "Veterinary Care",
      "Shelter Support",
      "Adoption Drives",
    ],
    image: assets.impact.Goshala,
  },
  {
    id: "Blood Donation",
    slug: "blood-donation",
    summary:
      "Community blood donation camps and donor networks supporting hospitals across Telangana.",
    programs: [
      "Donor Registration",
      "Camp Organization",
      "Hospital Partnerships",
      "Awareness Drives",
    ],
    image: assets.impact["Blood Donation"],
  },
  {
    id: "Blanket Distribution",
    slug: "blanket-destitution",
    summary:
      "Winter blanket drives, night shelters, and rehabilitation support for people without homes.",
    programs: [
      "Winter Relief",
      "Night Shelters",
      "Basic Necessities",
      "Rehabilitation Support",
    ],
    image: assets.impact["Blanket Distribution"],
  },
  {
    id: "Skill Development",
    slug: "skill-development",
    summary:
      "Vocational training, industry partnerships, and placement support for youth.",
    programs: [
      "Vocational Training",
      "Industry Partnerships",
      "Certification",
      "Placement Support",
    ],
    image: assets.impact["Skill Development"],
  },
] as const;

export type ImpactCategory = (typeof impactCategories)[number];
